import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const URLV2 = process.env.REACT_APP_API_V2;
const viewMatrix = 'matrix/view';
const listPeriodMatrix = 'matrix/list-periode';
const changeMatrix = 'matrix/change';
const setClosedStat = 'matrix/set-closed-status';
const createMatrix = 'matrix/create';
const structureStat = 'matrix/structure-status';
const mergeMatrix = 'matrix/merge';
const listConflict = 'matrix/list-conflict';
const listPivot = 'pivot/list';
const newViewMatrix = 'matrix/view-organization';
const importMatrix = 'matrix/import';
const viewProccess = 'matrix/view-process';
const viewStructure = 'matrix/view-structure';
const viewDetailProcess = 'matrix/arcesi-detail';
const exportDataMatrix = 'matrix/export-data';
const downloadExportData = 'matrix/download-export-data';
const findBusinessProcessUrl = 'matrix/search-process';
// VIEW
export const getViewMatrix = async (val) => {
  const datas = await http.post(`${URL + viewMatrix}`, val);
  return datas.data.data;
};
// LIST PERIODE
export const getListPeriodMatrix = async (val) => {
  const datas = await http.post(`${URL + listPeriodMatrix}`, val);
  return datas.data.data;
};
// CHANGE MATRIX
export const getChangeMatrix = async (val) => {
  const datas = await http.post(`${URL + changeMatrix}`, val);

  return datas.data;
};
// SET CLOSED MATRIX
export const postClosedStat = async (val) => {
  const datas = await http.post(`${URL + setClosedStat}`, val);
  return datas.data;
};
// CREATE
export const postCreateMatrix = async (val) => {
  const datas = await http.post(`${URL + createMatrix}`, val);
  return datas.data;
};
// structure stat
export const getStructureStat = async (val) => {
  const datas = await http.post(`${URL + structureStat}`, val);
  return datas.data.data;
};
// merge
export const getMergeMatrix = async (val) => {
  const datas = await http.post(`${URL + mergeMatrix}`, val);
  return datas.data;
};
export const getListConflict = async (val) => {
  const datas = await http.post(`${URL + listConflict}`, val);
  return datas.data.data;
};
export const getPivotList = async (val) => {
  const datas = await http.post(`${URL + listPivot}`, val);
  return datas.data.data;
};
export const getViewMatrixRevamp = async (val) => {
  const datas = await http.post(`${URL + newViewMatrix}`, val);
  return datas.data.data;
};
export const postImportMatrix = async (val) => {
  const datas = await http.post(`${URL + importMatrix}`, val);
  return datas.data;
};
export const getViewMatrixProcess = async (val) => {
  const datas = await http.post(`${URL + viewProccess}`, val);
  return datas.data.data;
};
export const getViewMatrixStructureV2 = async (val) => {
  const datas = await http.post(`${URLV2 + viewStructure}`, val);

  return datas.data;
};
export const getViewMatrixProcessV2 = async (val) => {
  const datas = await http.post(`${URLV2 + viewProccess}`, val);
  return datas.data.data;
};
export const getViewDetailProcess = async (val) => {
  const datas = await http.get(`${URLV2 + viewDetailProcess}`, {
    params: { ...val },
  });
  return datas.data.data;
};

export const getExportDataMatrix = async (val) => {
  const datas = await http.get(`${URLV2 + exportDataMatrix}`, {
    params: { ...val },
  });
  return datas.data.data;
};
export const getDownloadExportData = async (val) => {
  const datas = await http.get(`${URLV2 + downloadExportData}`, {
    params: { ...val },
  });
  return datas.data.data;
};

export const findBusinessProcess = async (val) => {
  const datas = await http.get(`${URLV2 + findBusinessProcessUrl}`, {
    params: { ...val },
  });
  return datas.data.data;
};
